import type { InputHTMLAttributes } from 'react'

import { StyledSearchInput } from './SearchInput.Styled'

type SearchInputProps = InputHTMLAttributes<HTMLInputElement>

export const SearchInput = ({ ...htmlProps }: SearchInputProps) => {
  return (
    <StyledSearchInput
      {...htmlProps}
      autoComplete="off"
      name="exercise-search"
      type="search"
    />
  )
}
